import QuotationScreen from './index';
import DetailScreen from './detail';

const routes = [
  {
    path: '/quotation',
    component: QuotationScreen,
  },
  {
    path: '/quotation/:id',
    component: DetailScreen,
  },
];

export default routes;
